<template>
  <div class="animated fadeIn compras-abm">
    <b-row>
      <b-col xl="12">
        <b-form class="form-compra">
          <b-card>
            <b-form-group
              v-if="!pagoImpuestos"
              label="Proveedor"
              label-for="proveedor"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarProveedor">
                  <b-input-group-text>
                    <i class="fa fa-search"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="proveedor"
                  :value="proveedorNombre"
                  readonly
                  type="text"/>
              </b-input-group>
            </b-form-group>

            <b-form-group
              v-if="pagoImpuestos"
              label="Organismo"
              label-for="impuestoOrganismo"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="impuestoOrganismo"
                :value="impuestoOrganismoNombre"
                readonly
                type="text"/>
            </b-form-group>

            <b-form-group
              v-if="pagoImpuestos"
              label="Impuesto"
              label-for="impuesto"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarImpuesto">
                  <b-input-group-text>
                    <i class="fa fa-search"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="impuesto"
                  :value="proveedorNombre"
                  readonly
                  type="text"/>
              </b-input-group>
            </b-form-group>

            <b-form-group
              v-if="pagoImpuestos"
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="incluirImpuestosOrganismo"
                  v-model="estadoIncluirImpuestosOrganismo"
                  :disabled="!incluirImpuestosOrganismoEnabled"
                  @click.native.prevent="getDeudaProveedor">
                  Incluir todos los impuestos del organismo
              </b-form-checkbox>
            </b-form-group>
          </b-card>
        </b-form>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="12">
        <b-card>
          <b-table hover
              responsive="sm" 
              class="registro cuenta-corriente"
              :busy="tableBusy"
              :items="cuentaCorrienteDisplay" 
              :fields="cuentaCorrienteFields"
              :current-page="paginaActual"
              :per-page="registrosPorPagina">
            <template v-slot:cell(fechaRegistro)="data">
              {{ data.item.fechaRegistro | fecha }}
            </template>
            <template v-slot:cell(fechaVencimiento)="data">
              {{ data.item.fechaVencimiento | fecha }}
            </template>
            <template v-slot:cell(periodo)="data">
              {{ data.item.periodo | periodo }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda(data.item.moneda) }}
            </template>
            <template v-slot:cell(saldo)="data">
              {{ data.item.saldo | moneda(data.item.moneda) }}
            </template>
            <template v-slot:cell(selected)="data">
              <b-form-checkbox 
                  v-model="data.item.selected"
                  :disabled="data.item.seleccionDisabled"
                  :value="Boolean(true)"
                  :unchecked-value="Boolean(false)"
                  @input="seleccionarCuentaCorriente(data.item)">
              </b-form-checkbox> 
            </template>                
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="12">
        <b-form>
          <b-card>
            <b-row>
              <b-col xl="6">
                <b-form-group
                  label="Total Comprobantes"
                  label-for="totalCuentaCorrientePesos"
                  :label-cols="4"
                  horizontal>
                  <b-form-input 
                    id="totalCuentaCorrientePesos"
                    :value="totalCuentaCorrientePesos | moneda"
                    readonly>
                  </b-form-input>
                </b-form-group>
            
                <b-form-group
                  label="Total Seleccionado"
                  label-for="totalSeleccionadoPesos"
                  :label-cols="4"
                  horizontal>
                  <b-form-input 
                    id="totalSeleccionadoPesos"
                    :value="totalSeleccionadoPesos | moneda"
                    readonly>
                  </b-form-input>
                </b-form-group>
              </b-col>

              <b-col xl="6">
                <b-form-group
                  label="Total Comprobantes"
                  label-for="totalCuentaCorrienteDolares"
                  :label-cols="4"
                  horizontal>
                  <b-form-input 
                    id="totalCuentaCorrienteDolares"
                    :value="totalCuentaCorrienteDolares | moneda('usd')"
                    readonly>
                  </b-form-input>
                </b-form-group>
            
                <b-form-group
                  label="Total Seleccionado"
                  label-for="totalSeleccionadoDolares"
                  :label-cols="4"
                  horizontal>
                  <b-form-input 
                    id="totalSeleccionadoDolares"
                    :value="totalSeleccionadoDolares | moneda('usd')"
                    readonly>
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
        </b-form>
      </b-col>
    </b-row>

    <b-modal ref="searchProveedorModal" 
        title="Seleccionar Proveedor"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="proveedores-search-modal">
      <app-search-proveedor
        @proveedorSeleccionado="proveedorSeleccionado">
      </app-search-proveedor>  
    </b-modal>

    <b-modal ref="searchImpuestoModal" 
        title="Seleccionar Impuesto"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="proveedores-search-modal">
      <app-search-impuesto
        @impuestoSeleccionado="impuestoSeleccionado">
      </app-search-impuesto>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import SearchProveedor from '../proveedores/SearchList.vue'
import SearchImpuesto from '../impuestos/SearchList.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import moment from 'moment'

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'pago/getField',
  mutationType: 'pago/updateField',
});

export default {
  name: 'PagoComprobantes',
  components: {
    appSearchProveedor: SearchProveedor,
    appSearchImpuesto: SearchImpuesto,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      cuentaCorrienteFields: [
        { 
          key: 'fechaRegistro',
          label: 'Fecha'
        },
        { key: 'fechaVencimiento' },
        { 
          key: 'comprobanteTipo',
          label: 'Comprobante'
        },
        { 
          key: 'comprobanteNumero',
          label: 'Nro.Comprobante'
        },
        { 
          key: 'importe',
          class: 'text-right'
        },
        { 
          key: 'saldo',
          class: 'text-right'
        },
        { 
          key: 'selected',
          label: '',
          class: 'text-center'
        },
      ],

      readOnly: new Boolean(true),
      cotizacionReadOnly: true,
      tableBusy: false,
      labelCols: 1,
    }
  },
  computed: {
    ...mapFields([
      'pagoImpuestos',
      'incluirImpuestosOrganismo',

      'id',
      'proveedor',
      'proveedorNombre',
      'impuestoOrganismoNombre',
      'cuentaCorrienteDisplay',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'totalCuentaCorrientePesos',
      'totalSeleccionadoPesos',
      'totalCuentaCorrienteDolares',
      'totalSeleccionadoDolares',
    ]),
    estadoIncluirImpuestosOrganismo: {
      get: function () {
        return this.incluirImpuestosOrganismo;
      },
      set: function (newValue) {
      }
    },
    incluirImpuestosOrganismoEnabled: {
      get: function () {
        if (this.proveedor) {
          if(this.proveedor.id) {
            if(this.proveedor.id != 0) {
              return true;
            }
          }
        }
        return false;
      },
      set: function (newValue) {
      }
    },
  },
  created() {
    if ((/true/i).test(this.pagoImpuestos)) {
      this.cuentaCorrienteFields = [
        { 
          key: 'fechaRegistro',
          label: 'Fecha'
        },
        { 
          key: 'proveedor',
          label: 'Impuesto'   
        },
        { key: 'periodo' },
        // { 
        //   key: 'comprobanteNumero',
        //   label: 'DD.JJ.'
        // },
        { 
          key: 'importe',
          class: 'text-right'
        },
        { 
          key: 'saldo',
          class: 'text-right'
        },
        { 
          key: 'selected',
          label: '',
          class: 'text-center'
        },
      ]
    }
  },
  activated() {
    this.validarOrdenPago();
  },
  methods: {
    seleccionarProveedor() {
      this.$refs.searchProveedorModal.show();
    },
    proveedorSeleccionado(item) {
      this.$refs.searchProveedorModal.hide();
      this.showSpinner();
      this.$store.dispatch('pago/setProveedor', item)
        .then (() => this.validarOrdenPago())
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    seleccionarImpuesto() {
      this.$refs.searchImpuestoModal.show();
    },
    impuestoSeleccionado(item) {
      this.$refs.searchImpuestoModal.hide();
      this.showSpinner();
      this.$store.dispatch('pago/setProveedor', item)
        .then (() => this.validarOrdenPago())
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    seleccionarCuentaCorriente(item) {
      this.$store.dispatch('pago/seleccionarCuentaCorriente', item.id)
        .catch(error => this.showErrorMsj(error));
      // this.$store.dispatch('pago/calcularTotalSeleccionado');
    },
    validarOrdenPago() {
      this.$emit('can-continue', { value: false });

      if (this.proveedor) {
        if (this.proveedor.id != 0) {
          this.$emit('can-continue', { value: true });
        }
      }
    },
    getDeudaProveedor() {
      if ((/true/i).test(this.incluirImpuestosOrganismoEnabled)) {
        this.incluirImpuestosOrganismo = !this.incluirImpuestosOrganismo;
        this.showSpinner();
        this.$store.dispatch('pago/getDeudaProveedor')
          .then (() => this.validarOrdenPago())
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    }
  },
  watch: {
  },
}
</script>

<style>
</style>
